import { render } from "./EditRemark.vue?vue&type=template&id=cb147f42&scoped=true&ts=true"
import script from "./EditRemark.vue?vue&type=script&lang=ts"
export * from "./EditRemark.vue?vue&type=script&lang=ts"

import "./EditRemark.vue?vue&type=style&index=0&id=cb147f42&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb147f42"]])

export default __exports__